// extracted by mini-css-extract-plugin
export var searchHeader = "_1y-0";
export var searchHeaderDark = "_1y-1";